/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


// (function() {

$(document).ready(function(){
  
  // Add custom code below this line

  $(document).on('click','#term_condition_checkbox',function(){
  
    if($(this).is(':checked')){
      $(".cart__checkout").attr('disabled',false)
    }else{
      $(".cart__checkout").attr('disabled',true)
    }
  
  })

  $(document).on('click','.custom_accordion__title',function(){
  	console.log(1)
    $(this).toggleClass('is-open');
    $(this).next('.custom_accordion__body').slideToggle();
  });
  

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.

});
  // })();



